import { ReactNode } from "react";
import styled from "styled-components";

const CardWrapper = styled.div<{ color: string }>`
  width: 100%;
  padding: 1.5rem;
  border-left: 0.5rem solid ${({ color }) => color};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};

  .l-info {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    h3 {
      font-weight: 600;
      font-size: 1.2rem;
      color: ${({ color }) => color};
    }

    h2 {
      font-size: 1.5rem;
      span {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.prim_200};
        font-weight: 400;
      }
    }
  }
`;

export interface ILargeCardProps {
  icon: ReactNode;
  value: number;
  title: string;
  color: string;
  description?: string;
}

export function LargeCard({
  icon,
  title,
  color,
  value,
  description,
}: ILargeCardProps) {
  return (
    <CardWrapper color={color}>
      <div className="l-info">
        <h3>{title}</h3>
        <h2>
          {value} {description && <span>({description})</span>}
        </h2>
      </div>
      {icon}
    </CardWrapper>
  );
}
